import { Engine, Entity } from "excalibur";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { hasTargetManager, TargetableComponent } from "../ecs/target";
import { hasHudInterface, HudInterface } from "../hud";
import { MyLevel } from "../level";
import "./App.css";
import DebugPane from "./DebugPane";
import Hud from "./Hud";
import Museum from "./Museum";

export interface AppProps {
  game: Engine;
}

const App: React.FC<AppProps> = ({ game }) => {
  const [showMuseum, setShowMuseum] = useState(false);

  const [hoverTarget, setHoverTarget] = useState<
    Entity<TargetableComponent> | undefined
  >();
  const [hudInterface, setHudInterface] = useState<HudInterface | null>(null);
  const [showShop, setShowShop] = useState(false);
  const [showGameOver, setShowGameOver] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  // Check URL parameter for forcing overlay display
  const urlParams = new URLSearchParams(window.location.search);
  const forceShowOverlays = urlParams.get("showOverlays") === "true";


  useEffect(() => {
    const updateInterval = setInterval(() => {
      const currentScene = game.currentScene;

      if (currentScene) {
        // Update target tracking
        if (hasTargetManager(currentScene)) {
          setHoverTarget(currentScene.targetManager.hoverTarget);
        }

        // Update scene-specific data
        if (currentScene instanceof MyLevel) {
          // Update HUD interface if available
          if (hasHudInterface(currentScene) && currentScene.hudInterface) {
            setHudInterface(currentScene.hudInterface);
            setShowShop(currentScene.hudInterface.showShop);
            setShowGameOver(currentScene.hudInterface.showGameOver);
            setShowHelp(currentScene.hudInterface.showHelp);
          }
        }
      }
    }, 100);

    return () => clearInterval(updateInterval);
  }, [game]);


  return (
    <>
      {/* Left panel content - render into the left-panel div - ONLY FOR DEBUG */}
      {ReactDOM.createPortal(
        <>
          <div className="museum-toggle" data-testid="museum-toggle-div">
            <label
              onClick={(evt) => {
                setShowMuseum(!showMuseum);
                evt.preventDefault();
              }}
            >
              <input
                type="checkbox"
                name={"showMuseum"}
                data-testid="museum-toggle"
                checked={showMuseum}
                readOnly
              />
              Show Museum
            </label>
          </div>

          <div className="debug-panel">
            <DebugPane game={game} />
          </div>
        </>,
        document.getElementById("left-panel")!,
      )}

      {/* Main overlay content - HUD or Museum */}
      {showMuseum ? (
        <Museum
          filename="images/playables.png"
          height={32}
          width={32}
          maxX={9}
          maxY={5}
          marginX={0}
          marginY={0}
          originX={0}
          originY={0}
        />
      ) : hudInterface ? (
        <Hud
          fps={0}
          hoverTarget={hoverTarget}
          hudController={hudInterface}
          showShop={showShop}
          showGameOver={showGameOver}
          showHelp={showHelp}
          forceShowOverlays={forceShowOverlays}
          game={game}
        />
      ) : null}
    </>
  );
};

export default App;
